export default "__VITE_ASSET__QnAyKALe__"